module.exports = __webpack_public_path__ + "static/media/exo-latin-200italic.61106667.woff2";